import { render, staticRenderFns } from "./MenuContent.vue?vue&type=template&id=00595c55&scoped=true&"
import script from "./MenuContent.vue?vue&type=script&lang=js&"
export * from "./MenuContent.vue?vue&type=script&lang=js&"
import style0 from "./MenuContent.vue?vue&type=style&index=0&id=00595c55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00595c55",
  null
  
)

export default component.exports